import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../lib/i18n/LanguageContext';
import SEO from '../../components/SEO';

// Import the new modular components
import ReservationsHero from './ReservationsHero';
import ReservationForm from '../../components/forms/ReservationForm';
import ReservationsSidebar from './ReservationsSidebar';

const Reservations = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [t]);

  // Structured data for reservations page
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'FoodEstablishment',
      name: 'Rossopomodoro Reykjavik',
      image: 'https://rossopomodoro.is/images/hero11.jpg',
      url: 'https://rossopomodoro.is',
      telephone: '+354 561 0500',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Laugavegi 40a',
        addressLocality: 'Reykjavík',
        postalCode: '101',
        addressCountry: 'IS',
      },
      servesCuisine: 'Italian',
      priceRange: '$$',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '12:00',
          closes: '22:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Sunday',
          opens: '17:00',
          closes: '22:00',
        },
      ],
      potentialAction: {
        '@type': 'ReserveAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://rossopomodoro.is/reservations',
          inLanguage: 'en',
          actionPlatform: [
            'http://schema.org/DesktopWebPlatform',
            'http://schema.org/IOSPlatform',
            'http://schema.org/AndroidPlatform',
          ],
        },
        result: {
          '@type': 'FoodEstablishmentReservation',
          name: 'Reservation',
        },
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://rossopomodoro.is/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Reservations',
          item: 'https://rossopomodoro.is/reservations',
        },
      ],
    },
  ];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEO
        title={`${t.reservations.hero.title} | Rossopomodoro`}
        description="Reserve your table at Rossopomodoro Reykjavik, best Italian restaurant downtown. Book online for authentic Neapolitan pizza & pasta. Laugavegur location."
        canonical="https://rossopomodoro.is/reservations"
        keywords="book table Rossopomodoro Reykjavik, Italian restaurant reservations, best pizza restaurant booking, Neapolitan pizza table booking, downtown Reykjavik dining"
        ldjson={structuredData}
      />

      {/* Page Hero */}
      <ReservationsHero t={t} />

      {/* Reservation Content */}
      <section className="py-20 bg-neutral-50">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Reservation Form */}
            <div className="lg:col-span-2">
              <ReservationForm showStepperOnMobile={true} showMapSection={true} />
            </div>

            {/* Sidebar Information */}
            <ReservationsSidebar t={t} />
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Reservations;
